// AuthSign.js
import React from 'react';
import toast from 'react-hot-toast';
import CryptoJS from 'crypto-js';


// Helper function to clear login data on failure
const clearLoginData = () => {
  localStorage.removeItem('authToken');
  localStorage.removeItem('username');
  localStorage.removeItem('permissions');
  localStorage.removeItem('userid');
  localStorage.removeItem('statuscode');
  localStorage.removeItem('agentid');
  localStorage.removeItem('type');
};

// Helper function to check if all required fields are stored correctly
const isAllStoredCorrectly = data => Object.keys(data).every(key => localStorage.getItem(key) === data[key]);


const AuthSign = async (
  values,
  history, 
  setIsLoggedIn, 
  setUsername, 
  apiGlobalforlogin, 
  setAgentId,
  setStatusCode,
  setUserId,
  setType,
  setPermissionsAccess,
  setCurrencyType,
  SetCurrencyCode,
  setCountryId,
) => {
  const { username, passwords } = values; 

  // const loginData = new URLSearchParams({
  //   email: username,
  //   password: passwords,
  // }).toString();

  const formData = new FormData();
  formData.append('email', username);
  formData.append('password', passwords);

  try {
    const response = await fetch(`${apiGlobalforlogin}/agent/login_api.php`, {
      method: 'POST',
      body: formData,
      // headers: {
      //   'Content-Type': 'application/json',
      // },
    });

    const result = await response.json();

    if (result?.message === 'Success' && result?.status) {
      if (result?.token) {
        // Clear old data before setting new session
        // localStorage.clear();
        toast.success('Login successful!');

        // Set State
        setIsLoggedIn(true);
        setUsername(result?.user_name);
        setAgentId(result?.agent_id);
        setUserId(result?.user_id);
        setStatusCode(result?.status_approve);
        setType(result?.type);
        setCurrencyType(result?.currency_id);
        SetCurrencyCode(result?.currency_code);
        setCountryId(result?.country_id);
        setPermissionsAccess(result?.permission || {});

        // Encryption key (should be stored securely in an environment variable)
        const secretKey = 'T4$Bv9#Aa@QWz8m&5!Lpo1kHsTz4jL2';

        // Encrypt data and store in localStorage
        const encryptedData = {
          authToken: result?.token,
          username: CryptoJS.AES.encrypt(result.user_name, secretKey).toString(),
          permissions: CryptoJS.AES.encrypt(JSON.stringify(result?.permission), secretKey).toString(),
          userid: CryptoJS.AES.encrypt(result.user_id.toString(), secretKey).toString(),
          statuscode: CryptoJS.AES.encrypt(result.status_approve.toString(), secretKey).toString(),
          agentid: CryptoJS.AES.encrypt(result.agent_id.toString(), secretKey).toString(),
          cid: CryptoJS.AES.encrypt(result?.country_id.toString(), secretKey).toString(),
          type: CryptoJS.AES.encrypt(result.type.toString(), secretKey).toString(),
          '78582826978678984898069': CryptoJS.AES.encrypt(result.currency_id.toString(), secretKey).toString(),
          '99117114114101110991219599111100101': CryptoJS.AES.encrypt(
          result.currency_code.toString(), 
          secretKey,
          ).toString(),
        };

        Object.entries(encryptedData).forEach(([key, value]) => {
          localStorage.setItem(key, value);
          // console.log(key, value);
        });

        // Validate if all required fields are set in localStorage
        if (isAllStoredCorrectly(encryptedData)) {
          setTimeout(() => {
            history.push('/app_dashboard'); 
          }, 2000);
        } else {
          // If some values are missing, rollback login state
          toast.error('Login failed: Data not stored correctly.');
          setIsLoggedIn(false);
          clearLoginData();
        }
      } else {
        toast.error('User Not Found');
        setIsLoggedIn(false);
      }
    } else {
      toast.error('User Not Authenticated');
    }
  } catch (error) {
    console.error('Error during login:', error);
    toast.error('Login failed. Please try again.');
  }
};



export default AuthSign;


